import { render, staticRenderFns } from "./NewMedicationUnit.vue?vue&type=template&id=0bbbef01&scoped=true"
import script from "./NewMedicationUnit.vue?vue&type=script&lang=js"
export * from "./NewMedicationUnit.vue?vue&type=script&lang=js"
import style0 from "./NewMedicationUnit.vue?vue&type=style&index=0&id=0bbbef01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbef01",
  null
  
)

export default component.exports